// Service functions for dashboard

import flow from 'lodash/flow'
import filter from 'lodash/fp/filter'
import join from 'lodash/fp/join'
import isUndefined from 'lodash/fp/isUndefined'
import trim from 'lodash/fp/trim'
import isNull from 'lodash/isNull'
import isEmpty from 'lodash/isEmpty'
import constant from 'lodash/constant'
import cond from 'lodash/cond'
import stubTrue from 'lodash/stubTrue'

// Generates the name from a lead. Returns, depending on what's available:
// 
// - First name and last name
// - First name
// - Last name
// - E-mail
// - Given placeholder
const getLeadName = (lead, fallback) => flow([
  filter(name => !isUndefined(name) || !isNull(name)),
  join(' '),
  trim,
  name => cond([
    // If name is not empty, return it
    [name => !isEmpty(name), constant(name)],

    // If email is set, return email
    [() => !isUndefined(lead.email) || !isNull(lead.email), constant(lead.email)],

    // If we have no email or name, return fallback
    [stubTrue, constant(fallback)]
  ])(name),
])([lead.firstname, lead.lastname])

export {
  getLeadName
}



// WEBPACK FOOTER //
// ./src/components/pages/dashboard/services/DashboardService.js